import * as z from 'zod'

import { BaseSchema_TravelHealthV1BerlinDirektDe } from '@flows/insurance/schemas'

const memberShape =
  BaseSchema_TravelHealthV1BerlinDirektDe.shape.insured_family_members.unwrap().element.shape

export const familyMemberSchema = z.object({
  first_name: memberShape.first_name.unwrap(),
  last_name: memberShape.last_name.unwrap(),
  born_on: memberShape.born_on,
  relationship_type: memberShape.relationship_type,
})
